"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferStatus = exports.TransferDirection = void 0;
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.TransferDirection = {
    Deposit: 'Deposit',
    Withdrawal: 'Withdrawal',
    Claim: 'Claim',
    Send: 'Send',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.TransferStatus = {
    Unknown: 'Unknown',
    Accepted: 'Accepted',
    Unconfirmed: 'Unconfirmed',
    Confirmed: 'Confirmed',
    Error: 'Error',
};
//# sourceMappingURL=exchangeAPI.schemas.js.map